/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  InsightsResponse,
  TriggerInsightsGenerationResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get the authenticated member's latest persona + generated narratives.

Returns an empty response (all nulls) if no narrative has been generated yet —
the FE should handle the loading state. The persona is included independently
so the FE can show partial state during the generation window between RA
submission and narrative completion.
 * @summary Get Insights
 */
export const getInsightsV1InsightsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<InsightsResponse>(
      {url: `/v1/insights`, method: 'GET', signal
    },
      );
    }
  



export const getGetInsightsV1InsightsGetQueryKey = () => {
    return [
    `/v1/insights`
    ] as const;
    }

    
export const getGetInsightsV1InsightsGetQueryOptions = <TData = Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInsightsV1InsightsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>> = ({ signal }) => getInsightsV1InsightsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInsightsV1InsightsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>>
export type GetInsightsV1InsightsGetQueryError = unknown


export function useGetInsightsV1InsightsGet<TData = Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightsV1InsightsGet>>,
          TError,
          Awaited<ReturnType<typeof getInsightsV1InsightsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsightsV1InsightsGet<TData = Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightsV1InsightsGet>>,
          TError,
          Awaited<ReturnType<typeof getInsightsV1InsightsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsightsV1InsightsGet<TData = Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Insights
 */

export function useGetInsightsV1InsightsGet<TData = Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsightsV1InsightsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInsightsV1InsightsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fire `InsightsGenerationWorkflow` for the caller's latest completed RA
response, if a narrative for it doesn't already exist.

Designed to be called from the FE's auth bootstrap so members who completed
RA before the narrative feature shipped (no `member_narratives` row on file)
get generation kicked off at login — maximizing the chance the narrative is
ready by the time they navigate to Risk Analysis.

Idempotent on three levels:
  1. DB short-circuit when a narrative row already exists for the member's
     latest response.
  2. Temporal workflow-ID dedup when a run is already in flight for the same
     (response_id, latest-answer-timestamp) pair.
  3. The persona child workflow itself short-circuits on an existing
     classification, so even a fresh parent run skips Claude persona work.

The DB check protects against re-burning Opus tokens after Temporal history
retention expires (typically 7-30 days), where workflow-ID dedup alone would
no longer prevent a duplicate run.
 * @summary Trigger Insights Generation
 */
export const triggerInsightsGenerationV1InsightsGeneratePost = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<TriggerInsightsGenerationResponse>(
      {url: `/v1/insights/generate`, method: 'POST', signal
    },
      );
    }
  


export const getTriggerInsightsGenerationV1InsightsGeneratePostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerInsightsGenerationV1InsightsGeneratePost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof triggerInsightsGenerationV1InsightsGeneratePost>>, TError,void, TContext> => {

const mutationKey = ['triggerInsightsGenerationV1InsightsGeneratePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerInsightsGenerationV1InsightsGeneratePost>>, void> = () => {
          

          return  triggerInsightsGenerationV1InsightsGeneratePost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerInsightsGenerationV1InsightsGeneratePostMutationResult = NonNullable<Awaited<ReturnType<typeof triggerInsightsGenerationV1InsightsGeneratePost>>>
    
    export type TriggerInsightsGenerationV1InsightsGeneratePostMutationError = unknown

    /**
 * @summary Trigger Insights Generation
 */
export const useTriggerInsightsGenerationV1InsightsGeneratePost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerInsightsGenerationV1InsightsGeneratePost>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerInsightsGenerationV1InsightsGeneratePost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getTriggerInsightsGenerationV1InsightsGeneratePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    